export default "__VITE_ASSET__CbAvYjWA__"